module.exports = __webpack_public_path__ + "img/no-trip-history.0815383f.svg";